export enum CessionSectionConsts {
  IBAN = 'iban',
  AMOUNT = 'amount',
  BANK_ID = 'bankId',
  IS_CESSION = 'isCession',
  POSTAL_CODE = 'postalCode'
}
